import React from 'react';
import { Clock, Mail, MapPin, Phone } from 'lucide-react';
import { business } from '../data/business';
import { services } from '../data/services';
type FooterProps = {
  logoVariant: 'badge' | 'wordmark';
};
export function Footer({
  logoVariant
}: FooterProps) {
  return <footer className="w-full bg-brand-navy pb-24 pt-16 text-white/80 sm:pb-16" data-id="element-34" data-mp="36pfsvtwnvp46">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-35" data-mp="36nd75m2jki59">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-36" data-mp="3ug3efhzi2d97">
          <div data-id="element-37" data-mp="38h5paxxbklh">
            <img src={logoVariant === 'wordmark' ? business.logoFull : business.logoBadge} alt={`${business.name} logo`} className={logoVariant === 'wordmark' ? 'h-24 w-auto rounded-2xl bg-white p-2' : 'h-16 w-16 rounded-full bg-white'} data-id="element-38" data-mp="38za4uuqp54h" />
            <p className="mt-4 text-sm leading-relaxed" data-id="element-39" data-mp="2ezuupo5l4cms">
              {business.tagline} — locally owned and operated in {business.city}.
            </p>
          </div>

          <div data-id="element-40" data-mp="3gb8vx23kfcv2">
            <h3 className="font-display text-sm tracking-tight text-white" data-id="element-41" data-mp="3gbr0cm0dsxe2">
              SERVICES
            </h3>
            <ul className="mt-4 space-y-2 text-sm" data-id="element-42" data-mp="3v9axx7uy7qa7">
              {services.map(service => <li key={service.id} data-id="element-43" data-mp="3q726ifxq4wa7">
                  <a href="#services" className="hover:text-brand-light" data-id="element-44" data-mp="830hxf7jlyyw">
                    {service.name}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-45" data-mp="hstt4f3rwc2m">
            <h3 className="font-display text-sm tracking-tight text-white" data-id="element-46" data-mp="htd236bg3q4i">
              CONTACT
            </h3>
            <ul className="mt-4 space-y-3 text-sm" data-id="element-47" data-mp="ctgznbiec6r2">
              <li className="flex items-center gap-2" data-id="element-48" data-mp="cw34329zq652">
                <Phone className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-49" data-mp="qub81u5g27pq" />
                <a href={business.phoneHref} className="hover:text-brand-light" data-id="element-50" data-mp="mspmzliran4g">
                  {business.phone}
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-51" data-mp="tt0a6tpgcss2">
                <Mail className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-52" data-mp="yv94puhz42wa" />
                <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-53" data-mp="13sr4ove0j7s5">
                  {business.email}
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-54" data-mp="1cmdywh2ko2z8">
                <MapPin className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-55" data-mp="1cnyortdxyxqr" />
                {business.city}
              </li>
              <li className="flex items-center gap-2" data-id="element-56" data-mp="1mj8qeg0fh340">
                <Clock className="h-4 w-4 text-brand-blue" aria-hidden="true" data-id="element-57" data-mp="1mhpbasqicy3t" />
                {business.hours}
              </li>
            </ul>
          </div>

          <div data-id="element-58" data-mp="3oc6p2sgvypwv">
            <h3 className="font-display text-sm tracking-tight text-white" data-id="element-59" data-mp="3ocpzlo47ic0v">
              FREE ESTIMATES
            </h3>
            <p className="mt-4 text-sm leading-relaxed" data-id="element-60" data-mp="3tc2wl1oskzh6">
              {business.owner}, owner &amp; operator. Licensed and insured
              Nebraska LLC.
            </p>
            <a href="#quote" className="mt-4 inline-block rounded-full bg-brand-blue px-5 py-3 text-sm font-bold text-white hover:bg-brand-blue-dark" data-id="element-61" data-mp="25mu8oqslaxp9">
              Get My Free Estimate
            </a>
          </div>
        </div>

        <p className="mt-12 border-t border-white/10 pt-6 text-xs text-white/50" data-id="element-62" data-mp="2tcy96pahehc1">
          © {new Date().getFullYear()} {business.name} · {business.website}
        </p>
      </div>
    </footer>;
}